// Színnév-fordító: a variánsok magyar színneveit (pl. "Fekete / tengerészkék")
// fordítja le token-alapon. A katalógus ~150 egyedi színneve mind ebből a
// ~60 alap-tokenből épül fel "/" elválasztókkal és zárójeles kiegészítőkkel.
// Ismeretlen token változatlanul marad (sosem lesz üres felirat).

const COLOR_TOKENS = {
  en: {
    'fekete': 'Black', 'fehér': 'White', 'szürke': 'Grey', 'kék': 'Blue', 'piros': 'Red',
    'sárga': 'Yellow', 'zöld': 'Green', 'narancs': 'Orange', 'narancssárga': 'Orange',
    'barna': 'Brown', 'bordó': 'Burgundy', 'bézs': 'Beige', 'búza': 'Wheat', 'cser': 'Tan',
    'erdőzöld': 'Forest green', 'ezüst': 'Silver', 'füst': 'Smoke', 'grafitszürke': 'Graphite grey',
    'halványkék': 'Pale blue', 'hamilton kék': 'Hamilton blue', 'homok szín': 'Sand',
    'indigó': 'Indigo', 'keki': 'Khaki', 'khaki': 'Khaki', 'királykék': 'Royal blue',
    'royal kék': 'Royal blue', 'royal': 'Royal', 'kő': 'Stone', 'kávébarna': 'Coffee brown',
    'tengerészkék': 'Navy', 'sötét tengerészkék': 'Dark navy', 'sötétkék': 'Dark blue',
    'tengerzöld': 'Sea green', 'kékeszöld': 'Teal', 'króm': 'Chrome', 'kvarc': 'Quartz',
    'kvarc kék': 'Quartz blue', 'lila': 'Purple', 'metró kék': 'Metro blue',
    'metál szürke': 'Metal grey', 'mohazöld': 'Moss green', 'mélypiros': 'Deep red',
    'mélysárga': 'Deep yellow', 'méz': 'Honey', 'oliva': 'Olive', 'olívazöld': 'Olive green',
    'palaszürke': 'Slate grey', 'polarizált': 'Polarised', 'rozsda': 'Rust', 'rózsaszín': 'Pink',
    'szénszürke': 'Charcoal', 'tükrös': 'Mirrored', 'tükrös kék': 'Mirrored blue',
    'tükröződő': 'Reflective', 'türkíz': 'Turquoise', 'türkiz': 'Turquoise',
    'világos zöld': 'Light green', 'vízkék': 'Aqua blue', 'víztiszta': 'Clear',
    'zoom szürke': 'Zoom grey', 'égszínkék': 'Sky blue', 'éjszakai erdőzöld': 'Dark forest green',
    'üvegzöld': 'Bottle green', 'navy': 'Navy', 'barna kockás': 'Brown check', 'kockás': 'Checked',
    'egyszínű': 'solid'
  },
  de: {
    'fekete': 'Schwarz', 'fehér': 'Weiß', 'szürke': 'Grau', 'kék': 'Blau', 'piros': 'Rot',
    'sárga': 'Gelb', 'zöld': 'Grün', 'narancs': 'Orange', 'narancssárga': 'Orange',
    'barna': 'Braun', 'bordó': 'Bordeaux', 'bézs': 'Beige', 'búza': 'Weizen', 'cser': 'Hellbraun',
    'erdőzöld': 'Waldgrün', 'ezüst': 'Silber', 'füst': 'Rauchgrau', 'grafitszürke': 'Graphitgrau',
    'halványkék': 'Hellblau', 'hamilton kék': 'Hamilton-Blau', 'homok szín': 'Sand',
    'indigó': 'Indigo', 'keki': 'Khaki', 'khaki': 'Khaki', 'királykék': 'Königsblau',
    'royal kék': 'Königsblau', 'royal': 'Royal', 'kő': 'Steingrau', 'kávébarna': 'Kaffeebraun',
    'tengerészkék': 'Marineblau', 'sötét tengerészkék': 'Dunkles Marineblau', 'sötétkék': 'Dunkelblau',
    'tengerzöld': 'Meergrün', 'kékeszöld': 'Blaugrün', 'króm': 'Chrom', 'kvarc': 'Quarz',
    'kvarc kék': 'Quarzblau', 'lila': 'Lila', 'metró kék': 'Metroblau',
    'metál szürke': 'Metallgrau', 'mohazöld': 'Moosgrün', 'mélypiros': 'Dunkelrot',
    'mélysárga': 'Dunkelgelb', 'méz': 'Honig', 'oliva': 'Oliv', 'olívazöld': 'Olivgrün',
    'palaszürke': 'Schiefergrau', 'polarizált': 'Polarisiert', 'rozsda': 'Rostrot', 'rózsaszín': 'Rosa',
    'szénszürke': 'Anthrazit', 'tükrös': 'Verspiegelt', 'tükrös kék': 'Verspiegelt Blau',
    'tükröződő': 'Reflektierend', 'türkíz': 'Türkis', 'türkiz': 'Türkis',
    'világos zöld': 'Hellgrün', 'vízkék': 'Wasserblau', 'víztiszta': 'Klar',
    'zoom szürke': 'Zoom-Grau', 'égszínkék': 'Himmelblau', 'éjszakai erdőzöld': 'Dunkles Waldgrün',
    'üvegzöld': 'Flaschengrün', 'navy': 'Marineblau', 'barna kockás': 'Braun kariert', 'kockás': 'Kariert',
    'egyszínű': 'einfarbig'
  },
  zh: {
    'fekete': '黑色', 'fehér': '白色', 'szürke': '灰色', 'kék': '蓝色', 'piros': '红色',
    'sárga': '黄色', 'zöld': '绿色', 'narancs': '橙色', 'narancssárga': '橙色',
    'barna': '棕色', 'bordó': '酒红色', 'bézs': '米色', 'búza': '小麦色', 'cser': '棕褐色',
    'erdőzöld': '森林绿', 'ezüst': '银色', 'füst': '烟灰色', 'grafitszürke': '石墨灰',
    'halványkék': '淡蓝色', 'hamilton kék': '汉密尔顿蓝', 'homok szín': '沙色',
    'indigó': '靛蓝', 'keki': '卡其色', 'khaki': '卡其色', 'királykék': '宝蓝色',
    'royal kék': '宝蓝色', 'royal': '宝蓝', 'kő': '石色', 'kávébarna': '咖啡棕',
    'tengerészkék': '藏青色', 'sötét tengerészkék': '深藏青', 'sötétkék': '深蓝色',
    'tengerzöld': '海绿色', 'kékeszöld': '蓝绿色', 'króm': '铬色', 'kvarc': '石英色',
    'kvarc kék': '石英蓝', 'lila': '紫色', 'metró kék': '地铁蓝',
    'metál szürke': '金属灰', 'mohazöld': '苔藓绿', 'mélypiros': '深红色',
    'mélysárga': '深黄色', 'méz': '蜜色', 'oliva': '橄榄色', 'olívazöld': '橄榄绿',
    'palaszürke': '板岩灰', 'polarizált': '偏光', 'rozsda': '铁锈色', 'rózsaszín': '粉色',
    'szénszürke': '炭灰色', 'tükrös': '镜面', 'tükrös kék': '镜面蓝',
    'tükröződő': '反光', 'türkíz': '绿松石色', 'türkiz': '绿松石色',
    'világos zöld': '浅绿色', 'vízkék': '水蓝色', 'víztiszta': '透明',
    'zoom szürke': 'Zoom 灰', 'égszínkék': '天蓝色', 'éjszakai erdőzöld': '暗森林绿',
    'üvegzöld': '瓶绿色', 'navy': '藏青色', 'barna kockás': '棕色格纹', 'kockás': '格纹',
    'egyszínű': '单色'
  }
};

const translateSegment = (segment, dict) => {
  const trimmed = segment.trim();
  if (!trimmed) return segment;
  // Zárójeles kiegészítő leválasztása: "Fekete (egyszínű)" → fő + zárójel
  const m = trimmed.match(/^([^(]+?)\s*\((.*)\)$/);
  if (m) {
    const main = translateSegment(m[1], dict);
    const innerWhole = dict[m[2].toLowerCase()];
    const inner = innerWhole || m[2].split(/\s+/).map(w => dict[w.toLowerCase()] || w).join(' ');
    return `${main} (${inner})`;
  }
  const whole = dict[trimmed.toLowerCase()];
  if (whole) return whole;
  // Szóközös összetételek szavankénti fordítása (pl. ismeretlen kombináció)
  const words = trimmed.split(/\s+/);
  if (words.length > 1) {
    const translated = words.map(w => dict[w.toLowerCase()] || w);
    if (translated.some((w, i) => w !== words[i])) return translated.join(' ');
  }
  return trimmed;
};

export const translateColor = (name, lang) => {
  if (!name || lang === 'hu') return name;
  const dict = COLOR_TOKENS[lang];
  if (!dict) return name;
  // "/" elválasztók megtartása az eredeti térközökkel
  return name.split(/(\s*\/\s*)/).map((part, i) =>
    i % 2 === 1 ? part : translateSegment(part, dict)
  ).join('');
};
